import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM13 8V16H15V8H13ZM9 8V16H11V8H9Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "PauseCircleFilled"
);
